
<template>
  <div style="display: block">
    <el-col :span="24" class="toolbar">
      <el-pagination
        background
        layout="prev, pager, next, total, jumper"
        style="float: right"
        small
        @size-change="handleSizeChange"
        @current-change="handleChange"
        :current-page="page"
        :page-size="limit"
        :total="totals"
      />
    </el-col>
  </div>
</template>
<script>
export default {
  name: "Fenye",
  props: {
    totals: 0, //总条数
    page: {
      type: Number,
      required: true,
    },
    // girls: {
    //     type: Array,
    //     required: true
    // },
    // noticeGirl: {
    //     type: String,
    //     required: false
    // }
  },
  data() {
    return {};
  },
  computed: {
    limit: {
      get: function () {
        return this.$store.state.limit;
      },
      set: function (newValue) {
        this.$store.state.limit = newValue;
      },
    },
  },
  methods: {
    handleChange(val) {
      this.$emit("paging", val);
    },
    handleSizeChange(val) {
      this.$emit("size", val);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-pagination {
  .btn-prev,
  .btn-next {
    width: 32px !important;
    height: 32px !important;
    border-radius: 4px !important;
    border: 1px solid #756991;
    background-color: transparent !important;
    font-size: 14px;
    font-weight: 400;
    color: #756991 !important;
    margin: 0 8px 0 8px !important;

    &:hover {
      background-color: #00f68c !important;
    }

    &:disabled {
      background-color: transparent !important;
    }
  }

  .el-pager {
    & > li {
      background-color: transparent !important;
      width: 32px !important;
      height: 32px !important;
      border-radius: 4px !important;
      border: 1px solid #756991 !important;
      line-height: 32px !important;
      font-size: 14px !important;
      font-weight: 400;
      color: #756991 !important;
      margin: 0 !important;

      &.active {
        background-color: transparent !important;
        background-image: linear-gradient(
          124deg,
          rgba(255, 255, 255, 0.06) 0%,
          rgba(255, 255, 255, 0.01) 100%
        ) !important;
        border: none !important;
        color: #00f68c !important;
      }
    }

    & > li + li {
      margin-left: 8px !important;
    }
  }

  .el-pagination__total {
    height: 32px !important;
    font-size: 14px !important;
    font-weight: 400;
    color: #b9c3c3 !important;
    line-height: 32px !important;
  }

  .el-pagination__jump {
    width: auto;
    height: 32px !important;
    font-size: 14px;
    font-weight: 400;
    color: #b9c3c3;
    line-height: 32px !important;

    .el-input {
      width: 64px !important;
      height: 32px !important;
      padding: 0 8px !important;
    }

    .el-input__inner {
      height: 32px !important;
      border-radius: 4px !important;
      color: #b9c3c3 !important;
      border: 1px solid #756991 !important;
      background-color: transparent !important;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/paging.vue